import { inject } from '@angular/core'
import { CanActivateFn, RedirectCommand, Router } from '@angular/router'

import { AuthService } from '../../../shared/services/auth.service'

export const demoAccountGuard: CanActivateFn = () => {
	const router = inject(Router)
	const authService = inject(AuthService)

	if (authService.loginResponse || !authService.isDemoUser()) {
		return true
	}

	return new RedirectCommand(router.parseUrl('/home'))
}
